import picking from './picking';
import shipping from './shipping';
import checking from './checking-new';
import sorting from './sorting';
import sortingWhileChecking from './sorting-while-checking';
import packing from './packing';
// import wavePlan from './wavePlan';

export default [
  ...picking,
  ...shipping,
  ...checking,
  ...sorting,
  ...packing,
  ...sortingWhileChecking,
];
